module.exports = __webpack_public_path__ + "img/newsATF.5f6147fa.jpg";